
(function(template){
define('vue!app/views/vue/components/packageDivComponent/packageScheduleComponent/timePicker',[
  "Vue",
  "moment",
  "vuex",
  "helpers",
  "underscore",
  "vue_scrollbar","vue!./bookForAllCheckBox","vue!./packageInfo",'vue!app/views/vue/basicComponents/radioButton','vue!app/views/vue/basicComponents/spdropdown','vue!basicComponents/timePickDropdown','vue!app/views/vue/components/cartComponent/cartBody/scheduleButtonComponent'
], function (
  Vue,
  moment,
  vuex,
  helpers,
  _, vue_scrollbar,bookForAllCheckBox,packageInfo,radioButton,spDropdown, regDropdown
,scheduleBtn) {
  return {
    template: template,
    name: "timePicker",
    data: function () {
      return {
       
        serviceBookedDate:"",
        HoverBoxHeight: "0px",
        showHoverBox: false,
        dataInHoverBox: [],
        available_times: [],
        selected_part_of_day: 'All day', //ALLDAAY,M,A,E,
        showAllTimeButton:true, //locally hide it when clicked,
        sticky_time_picker: false,
        dataInPackageInfoBox: [],
        noAvailabilityErrorMsg: '',
        allAvails: [],
        activeMethod: "",
        otbAddNewTime: ''

      }
    },
    props: [
      "spa_avail_times",
      "scheduling_package",
      "service_booked_time",
      "service_booked_date",
      "active_service_item_id", "error_message",'username','apply_staff_and_filter_logic','remove_time_choice','activeServiceBookedDateTime','isServiceBooked','set_active_packageItemId','service'
    ],
    components: {
      scrollbar: vue_scrollbar,
      'book-all-checkBox':bookForAllCheckBox,
       'package-Info':packageInfo,
       'radio-button':radioButton,
       'sp-dropdown':spDropdown,
       'reg-dropdown':regDropdown,
       'schedule-btn':scheduleBtn
    },
    computed: _.extend(vuex.mapState([
      "desktopMode",
      "isFetching",
      "selectedServices",
      ,"selectedTimeOnTimePicker","selectedDateOnDateBar", "users", 'bookForAllGuestCheckBox','dataForBookingService','detectedChanges','status','activeStep', 'OTBactive'
    ]), {
      dropdownOptions1: function(){
                        return _.values(this.localStrings.sideCart.service.body.otbPopupOptions1).slice(1);
                    },
      dropdownOptions2: function(){
          return _.values(this.localStrings.sideCart.service.body.otbPopupOptions2).slice(1);
      },
      options: function() {
        return this.localStrings.stepper.body.schedule.calendar.placeholder.partOfDay.Labels.map(function(str){
          return { name: str, val: str };
        })
      },
      showAvailableTimes: function () {
          if (this.spa_avail_times.data) {
            return ((this.spa_avail_times.data.length > 0 || this.available_times.length > 0) && !this.forceGenderSelect)
          }
        },
        forceGenderSelect: function () {
          var locationData = app.models.spaModel.getSelectedItem('spaLocations', {}),
              requireGender = locationData.ForceGenderSelect == "Y" && ( locationData.AllowGender == "Y" || locationData.AllowStaff == "Y")

          if (this.spa_avail_times.data && this.spa_avail_times.data.length > 0) {

            var staffSelected = this.users[this.username][this.active_service_item_id].staffGenderOrId;

            if (requireGender && (!staffSelected || staffSelected === 'X')) {
              this.noAvailabilityErrorMsg =  this.localStrings.stepper.body.schedule.errors.selectStaffFirst
              console.log('locationData', locationData)
              return true;
            }
            return false
          }
        },
      GetCountOfGuestsPerService: function () { //button will only show if count is more then 1
        var vm = this
        var count = 0;
        var service_id_trim = vm.active_service_item_id.split('-')[0]
        _.each(vm.users, function (user) {
          _.values(user).some(function (item) {
            if ( item.service && item.service.SpaItemId == service_id_trim && !item.SpaFolioItemId) count++;
          })
        })
        if (count <= 1 &&  this.bookForAllGuestCheckBox != false) vm.$store.commit("setBookForAllGuestCheckBox", false)
        return count // count of guests wanting to book same service
      },
      countOfTimesBookableForAll: function () { //check several logics to decide if all user can book -only in non package booking
        var possibleTimes = [];
        //if there exists atleast one time such that number of staff are greater or equal to number of rooms then it is true
        //if number of rooms are greater or equal o numb of staff avail and those staff are equal org reater then number of guests want to book then count plus
        // //if there exists atleast one time such that number of staff are greater or equal to num of guests willing to book then its true
        if (!this.scheduling_package && this.GetCountOfGuestsPerService > 1) {
          var vm = this;
          var service_id_trim = this.active_service_item_id.split('-')[0]
          if (Object.keys(this.spa_avail_times.staff[service_id_trim].allStaff).length > 1) {
            _.each(vm.spa_avail_times.rooms[service_id_trim], function (roomsPerTime, time) {
              var countOfStaffPerTime = vm.spa_avail_times.staff[service_id_trim][time].length
              var equipmentPerTime = vm.spa_avail_times.equipment[service_id_trim][time]

              if (roomsPerTime >= vm.GetCountOfGuestsPerService &&  (( equipmentPerTime >= vm.GetCountOfGuestsPerService)|| equipmentPerTime ==0) && countOfStaffPerTime >= vm.GetCountOfGuestsPerService) possibleTimes.push(time) //if number of rooms are greater or equal o numb of staff avail and those staff are equal org reater then number of guests want to book then count plus
            })
          }
        }
       // if(possibleTimes.length<=0 && this.bookForAllGuestCheckBox != false) this.$store.commit("setBookForAllGuestCheckBox", false)
        return possibleTimes
      },
      getShowMoreTimes: function () {
        return this.customization.configuration['showMoreTimes']
      },
      showPrefBeforeTime:function(){
        return this.customization.configuration['servicePrefBeforeTime']
      },
      stickyHeaderShow:function(){
        return this.showPrefBeforeTime && this.sticky_time_picker
      },
      ShowTimeLimit: function () {
        var vm = this
        if (vm.getShowMoreTimes.show && vm.showAllTimeButton ) {
            var additionalLogicResult = vm.additionalShowTimeLogic
            return additionalLogicResult ? vm.getShowMoreTimes.qty:vm.available_times.length
        } else return vm.available_times.length
      },
      ShowAllTimesLogic:function(){
        var vm =this
        if(vm.showAllTimeButton &&vm.getShowMoreTimes.show && vm.available_times.length > vm.ShowTimeLimit){
          var additionalLogicResult = vm.additionalShowTimeLogic
          return additionalLogicResult
        } else return false
      },
      additionalShowTimeLogic:function(){ // if times that are visible based on qty are disabled, then auto show all times.
        var AvailableTimeVisible = 0
        var isAvailableTimeVisible =false
        var vm = this
        if(vm.available_times.length> vm.getShowMoreTimes.qty){
        for(var i=0;i < vm.getShowMoreTimes.qty;i++){
          if(vm.available_times[i].showTime && vm.available_times[i].canBookAllGuest ){
            AvailableTimeVisible++;
          }
            isAvailableTimeVisible = !!AvailableTimeVisible
        }
      }
         return isAvailableTimeVisible
      },
      customerBkdList:function(){
        if(this.status == 'E' && this.OTBactive) return;
        var vm = this;
        return _.filter(this.users[this.username], function(el){
            return el.time && (vm.selectedDateOnDateBar == el.date) && (vm.service.SpaItemId == el.service.SpaItemId);
          })
      },
      dynamicRestShowTimes:function(){
        var vm = this;
        var showTimes = true;
        // Dynamic restriction code for spaPreventBookingDateRanges
        if(app.customization.dynamicRestrictions && app.commonViewHelper.active_ttb_effects.spaPreventBookingDateRanges){
          var spaPreventBookingDateResult = app.commonViewHelper.groupEffects(app.commonViewHelper.active_ttb_effects.spaPreventBookingDateRanges);
          if(spaPreventBookingDateResult.isActive && spaPreventBookingDateResult.value && spaPreventBookingDateResult.value.length){
            _.each(spaPreventBookingDateResult.value, function(timePeriod){
              if(timePeriod.startDate <= vm.selectedDateOnDateBar && vm.selectedDateOnDateBar <= timePeriod.endDate){
                showTimes = false;
                vm.noAvailabilityErrorMsg = vm.localStrings.stepper.body.schedule.errors.noAvailability;
                vmerror_message = vm.localStrings.stepper.body.schedule.errors.noAvailability;
                vm.$store.commit("setErrorMessage", vm.localStrings.stepper.body.schedule.errors.noAvailability);

              }
            })
          }
        }
        return showTimes;
      },
    }),
    created: function () {
      this.serviceBookedDate = this.service_booked_date
      this.$store.commit("SetselectedTimeOnTimePicker", this.service_booked_time)
      this.$store.commit("setSelectedDateTimeOnTimePicker", {dateTime:this.activeServiceBookedDateTime});
      this.available_times = this.spa_avail_times.data ? [].concat(this.spa_avail_times.data) : []
      window.addEventListener('scroll', this.handleScroll);
    },

    destroyed: function () {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      otbNewServInstance: function(){
        this.$store.commit('addService',{service:this.service, userId:this.username, setSelected:true})
        var userKeyIds = Object.keys(this.users[this.username]);
        this.$store.commit('setActiveService', userKeyIds[userKeyIds.length - 1]);
        this.$emit('set_add_new_otbData', userKeyIds[userKeyIds.length - 1], this.selectedDateOnDateBar, this.serviceBookedDate == this.selectedDateOnDateBar);
      },
      mergeBookedTimes: function(){
        if(this.status == 'E') return;
          var bkdArr = [];
          vm = this;

          //get booked times for day
          if(this.users[this.username]){
            bkdArr = this.customerBkdList;

            if(bkdArr.length){
              _.forEach(bkdArr, function(bkdSlot){
                var obj = {};
                obj.StartDateTime = bkdSlot.bookingDetails.StartDateTime;
                obj.startTime = bkdSlot.time;
                obj.canBookAllGuest = true;
                obj.showTime = true;
                obj.partOfDay = "";
                obj.otbIsBooked = true;
                obj.activeServId = bkdSlot.SpaItemId;
                vm.available_times.unshift(obj);
                vm.available_times = _.sortBy(vm.available_times, function(el){
                  return moment(el.StartDateTime.substr(0,10) + ' ' + el.startTime);
                })
                //filter times out that are already booked from normal avail list
                vm.available_times = _.filter(vm.available_times, function(el){return !(el.StartDateTime.substr(0, 10) == bkdSlot.date && el.startTime == bkdSlot.time && !el.otbIsBooked)});
                vm.available_times = _.uniq(vm.available_times, function(el){ return el.StartDateTime});
              })
            }
          }
      },
      onBkdBtnHover: function(time){
        $(".btn"+time.StartDateTime).css('visibility', 'visible');
      },
      onBkdBtnHovOut: function(time){
        $(".btn"+time.StartDateTime).css('visibility', 'hidden');
      },
      staffForSelectedTime: function(time){
        var obj = _.find(this.customerBkdList, function(el){ return el.bookingDetails.StartDateTime == time.StartDateTime});
        if(!obj) return;
        var staff = _.find(this.service.CapableStaff.Staff, function(el){return el.id == obj.bookingDetails.SpaStaffId}).name;
        return staff;
      },
      isValidForAdd: function(pickerTime){
        var pickerTime = pickerTime.StartDateTime.substr(0, 10) + " " + pickerTime.startTime;
        var pickerDateTime = moment(pickerTime);
        var currentSelected = moment(this.users[this.username][this.active_service_item_id].date + " " + this.users[this.username][this.active_service_item_id].time);
        var nextValid = moment(this.users[this.username][this.active_service_item_id].date + " " + this.users[this.username][this.active_service_item_id].time).add(this.service.ServiceTime, 'minutes');
        var prevValid = moment(this.users[this.username][this.active_service_item_id].date + " " + this.users[this.username][this.active_service_item_id].time).subtract(this.service.ServiceTime, 'minutes');
        if(pickerDateTime.isAfter(currentSelected) && pickerDateTime.isSameOrAfter(nextValid)){
          return true;
        }else if(pickerDateTime.isBefore(currentSelected) && pickerDateTime.isSameOrBefore(prevValid)){
          return true;
        }else{
          return false;
        }
      },
      toggleactiveMethod:function(bool){
                    this.activeMethod= bool
                },
      handleDropdownItemClick: function(option, x, time){
                    vm = this;
                    var userKeyIds = Object.keys(this.users[this.username]);
                    if(option == this.localStrings.sideCart.service.body.otbPopupOptions1.update) {
                      this.timePicker(time, 'proceed')
                    }else if(option == this.localStrings.sideCart.service.body.otbPopupOptions1.add){
                        this.otbNewServInstance();
                        this.otbAddNewTime = time;
                    }else if(option == this.localStrings.sideCart.service.body.otbPopupOptions2.remove){
                      var serviceItem = _.find(this.users[this.username], function(el){ return el.SpaItemId == (time.activeServId || vm.active_service_item_id)});
                        this.$store.commit("setStatus", '');
                        var activeUnbookedItemId = !this.users[this.username][this.active_service_item_id].time ? this.active_service_item_id : "";
                        helpers.removeService( serviceItem.SpaFolioItemId, this.service.SpaItemId, activeUnbookedItemId, this.username, '', this.service, otbCb);

                        function otbCb(){
                          vm.$emit('upd-active-id');
                        }

                        //remove user entry from schedulebtnValidity list. Part of age restrictions
                        this.$store.commit('setScheduleBtnValidity', {
                            id: this.userId,
                            action: "remove"
                        })
                    }
                },
      remove_staff_choice: function (val) {
        var vm = this;
        var itemId = vm.scheduling_package ? val : val.split('_')[1]
        var username = vm.scheduling_package ? vm.username : val.split('_')[0]
        vm.$emit('add-staff','X','Select Staff',"", itemId, username,true)
      },
      timePicker: function (time, action) {
        var vm = this
        this.$store.commit("SetselectedTimeOnTimePicker", time.startTime);
        this.$store.commit("setSelectedDateTimeOnTimePicker", {
          dateTime: time.StartDateTime
        });
        this.showHoverBox = true //remove later
        var bookOrderForSelectedTime = []
        this.$store.commit("setErrorMessage", "") // user clicks on time to book and if there exist " pick a time" error then remove it
        if (this.scheduling_package) {
         vm.$emit('add-PackageItem-In-Storage',time.combination)// for sending it to spa cotroller
          if (!this.desktopMode) this.addDataToPackageInfo(time.combination)
          _.each(time.combination, function (item) {
            vm.$emit('set-dirty-data', item.itemid, 'time', item.time)
            bookOrderForSelectedTime.push(item.itemid)
          })
          // reorder package item display if book order is different. Only do when service is not booked since it doesn't make sense to do it if the user is editing existing booking which booked in a certain order
          if(!vm.isServiceBooked){this.$store.commit('reorderPackageItems', {
            'highestCominations': bookOrderForSelectedTime,
            'id': vm.active_service_item_id,
            userId: vm.username
          })}
          this.set_active_packageItemId()// if package items were reordered then active package item has changed
        } else {
          var trimmedServiceId = this.active_service_item_id.split('-')[0] // if booking same service for all, time is for both
          this.$emit('set-dirty-data', this.active_service_item_id, 'time', time.StartDateTime)
        }
        this.$emit('filter-incompatible-staff',time.StartDateTime)
        $('.side-cart-button .user-info-reserve-button').focus();
        setTimeout(function(){
          if(vm.OTBactive && !vm.users[vm.username][vm.active_service_item_id].time || action == 'proceed')vm.$store.commit('SetbookFromCart',true)
        }, 100)
      },

      on_disabled_time_hover: function (time) {
        if (!time.showTime || time.canBookAllGuest == false) console.log("153h", this.$refs[time.startTime][0].style.visibility = "visible")
      },
      goToTimePicker: function () {
        var maxScoll = document.scrollingElement ?document.scrollingElement.scrollHeight - document.documentElement.clientHeight: 0
        var time_picker_clientHeight = this.$refs['sticky_time'].clientHeight || 0
        var time_picker_position = maxScoll - time_picker_clientHeight
        var time_picker_position = time_picker_clientHeight +60
        window.scrollTo({
          top: time_picker_position,
          left: 0,
          behavior: 'smooth'
        })
      },
      onButtonHover: function (event, data) {
          if (this.scheduling_package && data) {
            vm = this
            data = data.map(function (obj) {
              return {
                time: obj.time,
                duration: obj.duration,
                itemid: obj.itemid,
                startTime: moment(obj.time, "YYYY-MM-DDHHmmss").format('hh:mm a'),
                name: obj.name || obj.ItemName
              }
            })
            this.dataInHoverBox = [].concat(data)
            console.log("hoverdata", vm.dataInHoverBox)

            //display logic for hover

              var hoverBox = document.getElementById('h' + data[0].startTime)
              hoverBox?  hoverBox.style.display = 'inline-grid': ''
              var targetElement = event.target.offsetLeft + event.target.offsetWidth
              var hoverElement = hoverBox.offsetWidth
              var windowElement =window.outerWidth
              var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
              //SETTING HOVER TOP --
                //ios is behaving differently so I would need to modify pixel more
              var top = event.target.offsetTop
              iOS? top = top +7:''
              hoverBox.style.top=top +'px'
              //SETTING HOVER TOP --
              if (targetElement + hoverElement > windowElement){
                var left = (event.target.offsetLeft-hoverBox.offsetWidth) -20
                hoverBox.style.left=left +'px'
                hoverBox.classList.add('flipHover')
              }
              else{
                  hoverBox.classList.remove('flipHover')
                  if(iOS){
                     //ios is behaving differently so I would need to modify pixel more
                    var left = (event.target.offsetLeft-hoverBox.offsetWidth)
                    var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
                    iOS? left = left + 300:''
                   hoverBox.style.left=left +'px'
                  }
              }
          }
      },
      hide: function () {
       if(this.showHoverBox == true) this.showHoverBox = false
      },
      handleScroll: function () {
        this.showHoverBox = false
      },
      mouseOut: function (e, time) {
       // if(this.desktopMode) this.showHoverBox = !this.showHoverBox
       // else {
            var hoverBox = document.getElementById('h'+time)
            hoverBox ? hoverBox.style.display='none': ""
       // }
      },
      moment: function () {
        return moment();
      },
      mouseOutDisabledDiv: function (e, time) {
        if (!time.showTime || time.canBookAllGuest == false) this.$refs[time.startTime][0].style.visibility = "hidden"
      },
      part_of_day: function (e) {
        var vm = this
        var val = this.localStrings.stepper.body.schedule.calendar.placeholder.partOfDay[vm.selected_part_of_day]
        var afternoon = moment('11:59 am', 'hh:mm a')
        var evening = moment('04:59 pm', 'hh:mm a')
        if(vm.spa_avail_times.data && vm.spa_avail_times.data.length ){
        vm.available_times = (vm.available_times.length && vm.OTBactive ?  vm.available_times: vm.spa_avail_times.data).filter(function (times) {
          times.partOfDay = val
          var startTime = moment(times.startTime, 'hh:mm a')
          return val == "M" ? startTime.isBefore(afternoon) : val == "E" ? startTime.isAfter(evening) : val == "A" ? (startTime.isAfter(afternoon) && startTime.isBefore(evening)) : []
        }) || vm.spa_avail_times.data
        }
        vm.setAvailabilityError()
      },
      FilterAvailabilityPerGuests: function () { //this function is responsible for filtering availabilities if book for all is active; compares number of guest wanting to book same service vs num of staff available at any given time.o
        var vm = this
        var numOfGuest = vm.GetCountOfGuestsPerService
        var numOfValidTimes = vm.countOfTimesBookableForAll
        var checked = vm.bookForAllGuestCheckBox
        vm.available_times = _.each(vm.available_times, function (time) {
          if (numOfValidTimes.length>0 &&checked ) {
             if ((numOfValidTimes.indexOf(time.StartDateTime) > -1)) time['canBookAllGuest'] = true
            else time['canBookAllGuest'] = false
          } else time['canBookAllGuest'] = true // just to make all time available when unchecked
        })
        vm.$store.commit("SetselectedTimeOnTimePicker", "")
      },
      uncheck_book_for_all: function () {
        this.$store.commit("setBookForAllGuestCheckBox", !this.bookForAllGuestCheckBox)
        if (this.detectedChanges.time) this.remove_time_choice(this.active_service_item_id)

        // now support if user clicks on 9 am and ppeter is not available so it is disabled in stafflist.At this time user clicks on "book for all" and 9 am is not possble to book for all, then 9 am is also disabled.But because user previously clicked 9 am, staff ppter is still showing disabled even thought now 9 am is not selected because book for all logic. Therefore, in that case we make tha staff visible by running above function
        this.FilterAvailabilityPerGuests()
        this.apply_staff_and_filter_logic(this.bookForAllGuestCheckBox)
      },
      hideShowAllButton:function(){
        $('.service-time-picker button').focus();
        this.showAllTimeButton = !this.showAllTimeButton
      },
      onScroll:function(){
        var maxScoll = document.scrollingElement ?document.scrollingElement.scrollHeight - document.documentElement.clientHeight: 0
        var timeDom =this.$refs['sticky_time']
        var time_picker_clientHeight = timeDom? timeDom.clientHeight : 0
        var time_picker_position = maxScoll - time_picker_clientHeight
        if (window.pageYOffset <= time_picker_position-57) {
          this.sticky_time_picker = true
        } else this.sticky_time_picker = false
      },
      addDataToPackageInfo:function(data){
        data = data.map(function (obj) {
            return {
              startTime: moment(obj.time, "YYYY-MM-DDHHmmss").format('hh:mm a'),
              name: obj.name || obj.ItemName
            }
        })
        this.dataInPackageInfoBox = [].concat(data)
      },
      setAvailabilityError: function(){
        if(!this.spa_avail_times.data.length){
          this.noAvailabilityErrorMsg = this.localStrings.stepper.body.schedule.errors.noAvailability
        }
        else if(!this.available_times.length){
           this.noAvailabilityErrorMsg = this.localStrings.stepper.body.schedule.errors.noFilteredAvailability  + this.selected_part_of_day
        }
      },
      bookedTimeShowLogic: function( time) {

        var vm = this
        var bookedTime = vm.service_booked_time

        return vm.selectedTimeOnTimePicker == bookedTime && bookedTime == time && vm.selectedDateOnDateBar == vm.service_booked_date
      }
    },
    watch: {
      selected_part_of_day:function(val){
        var prefix = this.localStrings.stepper.body.schedule.calendar.placeholder.partOfDay[val]
        this.part_of_day(this.selected_part_of_day)
      },
      active_service_item_id: function () {
        this.$store.commit("SetselectedTimeOnTimePicker", "");
      },
      selectedDateOnDateBar: function (val) {
        var vm = this
        var isSelectedDateBooked = vm.selectedDateOnDateBar == vm.serviceBookedDate ? vm.service_booked_time: ""
         vm.$store.commit("SetselectedTimeOnTimePicker", isSelectedDateBooked);

         if(vm.bookForAllGuestCheckBox ) this.$store.commit("setBookForAllGuestCheckBox", false)
         if(this.isServiceBooked && this.service) {
            this.otbNewServInstance();
         }
      },
      isFetching:function(val){
        if(!val && this.isServiceBooked && this.selectedDateOnDateBar == this.serviceBookedDate ){
          this.$emit('filter-incompatible-staff',this.activeServiceBookedDateTime)//this is when editing. staff filter based on booked datetime
        }

        if(!val && this.otbAddNewTime && this.OTBactive){
            this.timePicker(this.otbAddNewTime);
            this.otbAddNewTime = "";
        }
      },

      service_booked_time: function (val) {
        this.$store.commit("SetselectedTimeOnTimePicker", this.service_booked_time);
      },
      service_booked_date:function(val){
          this.serviceBookedDate = val
      },
      spa_avail_times: {
        handler: function (newValue) {
          var vm = this;
          vm.available_times = [].concat(vm.spa_avail_times.data || [])
          vm.allAvails = [].concat(vm.spa_avail_times.data || [])
          vm.part_of_day()
          if(vm.OTBactive) vm.mergeBookedTimes();

        },
        deep: true
      }
    },
    mounted:function(){
        window.addEventListener('scroll', this.onScroll);
        this.$store.commit("setBookForAllGuestCheckBox", false);
        var membershipIds = app.data.membershipDetails && app.data.membershipDetails.membershipItemIds || [];
        var vipLevels = app.data.membershipDetails && app.data.membershipDetails.VIPLevels || [];
        app.commonViewHelper.eval_ttb({module:"spaBooking", item: this.users[this.username][this.active_service_item_id], vipLevel: vipLevels, membershipId:membershipIds});
    }

  }
})
})('<div class="timepicker-div-cont" :class="{\'no-avail\': !available_times.length && !allAvails.length && !isFetching, \'forceGenderErr\': forceGenderSelect} "> <div class="main-body-second-section" v-click-outside="hide"> <transition name="fade"> <div v-if="showHoverBox &&scheduling_package " class="tip package_box_left" id="we" :class="scheduling_package? \'tip-mobile\':null "> <div class="package_box_left_data" v-for="(data,key) in dataInHoverBox" :key="key"> <h3>{{data.name }}</h3> <p>{{localStrings.stepper.body.schedule.timePicker.startTimeLabel}} : {{ data.startTime}}</p> </div> </div> </transition> <div class="service-time-picker-div" ref="sticky_time"> <h1 @click="goToTimePicker" v-if="!desktopMode" :class="stickyHeaderShow?\'sticky_time_picker_header\':\'hide\'" role="button" aria-pressed="false" aria-label="Scroll to TimePicker"> <span> <span v-if="!scheduling_package">{{localStrings.stepper.body.schedule.timePicker.pickTimeLabel}}</span> <span v-else> {{localStrings.stepper.body.schedule.timePicker.packageSelectTimeLabel}} </span> <i aria-hidden="true" class="fa fa-caret-down" style=""></i> </span> </h1> <h1> <span v-if="!scheduling_package">{{localStrings.stepper.body.schedule.timePicker.pickTimeLabel}}</span> <span v-else>{{localStrings.stepper.body.schedule.timePicker.packageSelectTimeLabel}}</span> </h1> <p v-if="error_message && !desktopMode " role="alert" aria-live="polite" style="margin:auto;margin-bottom:20px" class="time-picker-error-message error alert-error .control-group.error"> {{this.error_message}} </p> <p v-if="isFetching">{{localStrings.stepper.body.schedule.loading}}</p> <p class="time-picker-error-message" role="alert" aria-live="polite" v-if="!isFetching && (forceGenderSelect || !available_times.length && !OTBactive)"> {{noAvailabilityErrorMsg || localStrings.stepper.body.schedule.errors.noAvailability}} </p> <p class="time-picker-error-message" role="alert" aria-live="polite" v-if="!available_times.length && !isFetching && OTBactive && !allAvails.length"> {{noAvailabilityErrorMsg || localStrings.stepper.body.schedule.errors.noAvailability}} </p> <div v-if="!isFetching &&showAvailableTimes && dynamicRestShowTimes" class="my-scrollbar" ref="Scrollbar"> <div> <book-all-checkBox :count_time_bookable_for_all="countOfTimesBookableForAll.length" :service_id="active_service_item_id" :username="username" :uncheck_book_for_all="uncheck_book_for_all"> </book-all-checkBox> <select class="pick-part-of-day-select" name id v-if="!desktopMode" @change="part_of_day($event.target.value)" v-model="selected_part_of_day"> <option :value="localStrings.stepper.body.schedule.calendar.placeholder.partOfDay.Labels[0]"> {{localStrings.stepper.body.schedule.calendar.placeholder.partOfDay.Labels[0]}}</option> <option :value="localStrings.stepper.body.schedule.calendar.placeholder.partOfDay.Labels[1]"> {{localStrings.stepper.body.schedule.calendar.placeholder.partOfDay.Labels[1]}}</option> <option :value="localStrings.stepper.body.schedule.calendar.placeholder.partOfDay.Labels[2]"> {{localStrings.stepper.body.schedule.calendar.placeholder.partOfDay.Labels[2]}}</option> <option :value="localStrings.stepper.body.schedule.calendar.placeholder.partOfDay.Labels[3]"> {{localStrings.stepper.body.schedule.calendar.placeholder.partOfDay.Labels[3]}}</option> <i class="fas fa-angle-down"></i> </select> <sp-dropdown v-else-if="OTBactive && (status != \'E\')" :options="options" :selected.sync="selected_part_of_day"></sp-dropdown> <radio-button v-else :options="options" :aria-label="\'Selected part of the Day\'" :selected.sync="selected_part_of_day"></radio-button> <p class=\'sp-NoTimes\' v-if="!available_times.length && !isFetching && OTBactive && (status != \'E\')"> {{noAvailabilityErrorMsg || localStrings.stepper.body.schedule.errors.noAvailability}} </p> <div :class="desktopMode?\'service-time-picker-times\':null"> <div @mouseenter="on_disabled_time_hover(time)" @mouseleave="mouseOutDisabledDiv($event,time)" class=" service-time-picker" v-for="(time,key) in available_times.slice(0,ShowTimeLimit)" :key="key" :disabled="time.startTime==selectedTimeOnTimePicker ?true:false"> <div> <reg-dropdown v-if="OTBactive && (time.startTime==selectedTimeOnTimePicker && (status != \'E\') && users[username][active_service_item_id].time) || time.otbIsBooked" :options="dropdownOptions2" :userId="username" :service_key="time" :options_header="localStrings.sideCart.service.body.otbPopupOptions1.otbPopupHeader" :activeMethod="activeMethod" @handleDropdown-ItemClick="handleDropdownItemClick" @toggle-active-Method="toggleactiveMethod" :disabled="isFetching"> <template v-slot:icon> <button class="btn btn-primary" :class="[(time.startTime==selectedTimeOnTimePicker || time.otbIsBooked ?\'time_picker_selected_date\':null),(time.otbIsBooked ? \'disabled\' : null),((!time.showTime || time.canBookAllGuest==false) ?\'disable_no_staff_avail_time\':null),(!time.available && scheduling_package?\'hide\':null)]" :disabled="!time.showTime || time.canBookAllGuest==false"> <p @mouseover="onButtonHover($event,time.combination), onBkdBtnHover(time)" v-on:mouseleave="mouseOut($event,time.startTime), onBkdBtnHovOut(time)"> <i class="fa fa-check" v-show="(service_booked_time == time.startTime && selectedDateOnDateBar == serviceBookedDate) || time.otbIsBooked"></i> {{time.startTime==selectedTimeOnTimePicker || time.otbIsBooked ? localStrings.stepper.body.spb.bookedText + \' \' : localStrings.stepper.body.spb.bookText + \' \'}}{{time.startTime}} <i v-show="!time.showTime || time.canBookAllGuest==false" class="fas fa-info-circle"></i> </p> </button> </template> </reg-dropdown> <reg-dropdown v-else-if="OTBactive && (status != \'E\') && users[username][active_service_item_id].time" :options="isValidForAdd(time) ? dropdownOptions1 : [].concat(dropdownOptions1[0])" :userId="username" :service_key="time" :options_header="localStrings.sideCart.service.body.otbPopupOptions1.otbPopupHeader" :activeMethod="activeMethod" @handleDropdown-ItemClick="handleDropdownItemClick" @toggle-active-Method="toggleactiveMethod" :disabled="isFetching"> <template v-slot:icon> <button class="btn btn-primary" :class="[(time.startTime==selectedTimeOnTimePicker ?\'time_picker_selected_date\':null),(!(time.startTime==selectedTimeOnTimePicker) && selectedTimeOnTimePicker ? \'disabled\' : null),((!time.showTime || time.canBookAllGuest==false) ?\'disable_no_staff_avail_time\':null),(!time.available && scheduling_package?\'hide\':null)]" :disabled="!time.showTime || time.canBookAllGuest==false"> <!-- <i class="fa fa-check" v-show="service_booked_time == time.startTime && selectedDateOnDateBar == serviceBookedDate" ></i> --> <p @mouseover="onButtonHover($event,time.combination)" v-on:mouseleave="mouseOut($event,time.startTime)"> {{time.startTime==selectedTimeOnTimePicker ? localStrings.stepper.body.spb.bookedText + \' \' : localStrings.stepper.body.spb.bookText + \' \'}}{{time.startTime}} <i v-show="!time.showTime || time.canBookAllGuest==false" class="fas fa-info-circle"></i> </p> </button> </template> </reg-dropdown> <button v-else-if="OTBactive && (status != \'E\')" class="btn btn-primary" :class="[(time.startTime==selectedTimeOnTimePicker ?\'time_picker_selected_date\':null),(!(time.startTime==selectedTimeOnTimePicker) && selectedTimeOnTimePicker ? \'disabled\' : null),((!time.showTime || time.canBookAllGuest==false) ?\'disable_no_staff_avail_time\':null),(!time.available && scheduling_package?\'hide\':null)]" :disabled="!time.showTime || time.canBookAllGuest==false" @click="timePicker(time)"> <!-- <i class="fa fa-check" v-show="service_booked_time == time.startTime && selectedDateOnDateBar == serviceBookedDate" ></i> --> <p @mouseover="onButtonHover($event,time.combination)" v-on:mouseleave="mouseOut($event,time.startTime)"> {{time.startTime==selectedTimeOnTimePicker ? localStrings.stepper.body.spb.bookedText + \' \' : localStrings.stepper.body.spb.bookText + \' \'}}{{time.startTime}} <i v-show="!time.showTime || time.canBookAllGuest==false" class="fas fa-info-circle"></i> </p> </button> <button v-else class="btn btn-primary" :class="[(time.startTime==selectedTimeOnTimePicker ?\'time_picker_selected_date\':null),((!time.showTime || time.canBookAllGuest==false) ?\'disable_no_staff_avail_time\':null),(!time.available && scheduling_package?\'hide\':null)]" :disabled="!time.showTime || time.canBookAllGuest==false" @click="timePicker(time)"> <i class="fa fa-check" v-show="service_booked_time == time.startTime && selectedDateOnDateBar == serviceBookedDate"></i> <p @mouseover="onButtonHover($event,time.combination)" v-on:mouseleave="mouseOut($event,time.startTime)"> {{time.startTime}} <i v-show="!time.showTime || time.canBookAllGuest==false" class="fas fa-info-circle"></i> </p> </button> <div class="tip package_box_left" v-if="time.StartDateTime != activeServiceBookedDateTime" :class="scheduling_package? \'tip-mobile\':null " :id="\'h\'+time.startTime"> <div class="package_box_left_data" v-for="(data,key) in dataInHoverBox" :key="key"> <h3>{{data.name }}</h3> <p>{{localStrings.stepper.body.schedule.timePicker.startTimeLabel}}: {{ data.startTime}}</p> </div> </div> </div> <transition class="fade"> <div class="disabled-time-hover" :ref="time.startTime" v-if="!time.showTime || time.canBookAllGuest==false"> <h4> {{localStrings.stepper.body.schedule.noStaffAvailLabel}} <div v-if="!scheduling_package"> <div v-if="bookForAllGuestCheckBox"> <div>{{localStrings.stepper.body.schedule.timePicker.bookForAll }} <span><i @click="uncheck_book_for_all" role="button" aria-pressed="false" aria-label="Uncheck Book for all" class="fas fa-times"></i></span> </div> <div v-for="(staff, key) in time.unavailableStaff" :key="key"> {{staff}} <span><i @click="remove_staff_choice(key)" role="button" aria-pressed="false" aria-label="Remove staff choice" class="fas fa-times"></i></span> </div> </div> <div v-else> {{time.unavailableStaff[username+\'_\'+active_service_item_id]}} <span><i @click="remove_staff_choice(username+\'_\'+active_service_item_id)" role="button" aria-pressed="false" aria-label="Remove staff choice" class="fas fa-times"></i></span> </div> </div> <div v-else v-for="(item,key) in time.combination" :key="key" v-show="!item.isTimePossible"><span> {{item.disabledStaff}} <i @click="remove_staff_choice(item.itemid)" role="button" aria-pressed="false" aria-label="Remove staff choice" class="fas fa-times"></i></span> </div> </h4> </div> <div :class="[\'staffHover\',\'disabled-time-hover\', (\'btn\' + time.StartDateTime)]" v-if="OTBactive && staffForSelectedTime(time)"> <p>{{localization.spaBooking.serviceSelection.providerHoverLabel}} {{staffForSelectedTime(time)}} </p> </div> </transition> </div> </div> <button v-show="ShowAllTimesLogic &&getShowMoreTimes.show" @click="hideShowAllButton" class="btn btn-primary show-all-time-button"> {{localStrings.stepper.body.schedule.timePicker.showAllTimes}} </button> <schedule-btn v-bind:is_service_booked="isServiceBooked" v-if="activeStep !=0 && desktopMode && !OTBactive && !customization.showBookBtnOnSideCart"></schedule-btn> </div> </div> </div> </div> <package-Info v-bind:dataInPackageInfoBox="dataInPackageInfoBox" v-bind:scheduling_package="scheduling_package"></package-Info> </div>');
